export default __webpack_public_path__ + "static/media/faq-man-woman.7366e395.png";